import {getState} from '../../lib/store';
import API from '../../lib/api';
import types from './types';
import { toast, ToastContainer } from 'react-toastify';
import globalTypes from '../types';

export const initialize = () => async dispatch => {
    const response = await API.call({
        path: '/modules/initialize'
    });

    if(response.success)
        dispatch({
            type: types.loaded,
            payload: response.data
        });
}

export const showModuleModal = key => {
    return {
        type: types.module_modals.show,
        payload: key
    }
}

export const showModal = key => {
    return {
        type: types.modals.show,
        payload: key
    }
}

export const updateModal = (modal, data) => {
    return {
        type: types.modals.update,
        payload: {
            path: modal,
            data
        }
    }
}

export const closeModuleModal = () => async dispatch => {
    const {modules} = getState(),
          {module_modals} = modules;

    const has_visible = module_modals.filter(m => m.visible)[0] || null;

    if(!has_visible)
        return;

    console.log('@moduleModal CLOSE TRIGGER', {
        key: has_visible.key,
        visible_time: Date.now() - has_visible.visible_at
    });

    dispatch({
        type: types.module_modals.close,
        payload: has_visible.triggerId
    });
}

export const closeModal = () => async dispatch => {
    const {modules} = getState(),
          {modals} = modules;

    const has_visible = modals.length > 0;

    if(!has_visible)
        return;

    dispatch({
        type: types.modals.close,
        payload: modals[modals.length - 1]
    });
}

export const redeemComebackReward = data => async dispatch => {
    dispatch({
        type: types.module_modals.update,
        payload: {
            path: 'modules_comeback_reward',
            data: {
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/modules/redeem_bonus',
        body: data
    });

    dispatch({
        type: types.module_modals.update,
        payload: {
            path: 'modules_comeback_reward',
            data: {
                button: false
            }
        }
    });

    if(response.success) {
        toast.dismiss();
        toast.success(response.message);

        dispatch(closeModuleModal());

        if(response.data) {
            if(response.data.deposit_bonus)
                dispatch({
                    type: globalTypes.user.deposit_bonus,
                    payload: response.data.deposit_bonus
                });

            if(response.data.transaction)
                dispatch({
                    type: globalTypes.games.history.add,
                    payload: response.data.transaction
                });

            if(response.data.balance)
                dispatch({
                    type: globalTypes.user.balance,
                    payload: response.data.balance
                });
        }
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const verifyFacebookPost = ({
    post_id,
    url
}) => async dispatch => {
    dispatch(updateModal('facebook_post', {
        verify: {
            button: true
        }
    }));

    const response = await API.call({
        path: '/tasks/facebook',
        body: {
            post_id,
            url
        }
    });    

    dispatch(updateModal('facebook_post', {
        verify: {
            button: false
        }
    }));

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: globalTypes.tasks.update.one,
            payload: {
                type: 'daily',
                task: 'facebook',
                data: response.task
            }
        });

        dispatch(closeModal());
    }
}

export const verifyFacebookStory = ({
    post_id,
    url
}) => async dispatch => {
    dispatch(updateModal('facebook_story', {
        verify: {
            button: true
        }
    }));

    const response = await API.call({
        path: '/tasks/facebook_story',
        body: {
            post_id,
            url
        }
    });    

    dispatch(updateModal('facebook_story', {
        verify: {
            button: false
        }
    }));

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: globalTypes.tasks.update.one,
            payload: {
                type: 'daily',
                task: 'facebook_story',
                data: response.task
            }
        });

        dispatch(closeModal());
    }
}